import { Buffer } from 'buffer';

async function uploadFromBase64(base64, key) {
    try {
        const base64Data = new Buffer.from(base64.replace(/^data:image\/\w+;base64,/, ""), 'base64');

        await window.VaporS3.store(base64Data, {
            data: {
                key,
            },
            contentType: 'image/png'
        });
    } catch (error) {
        console.error(error)
        throw new Error('Failed to create pdf thumbnail');
    }
}

export { uploadFromBase64 };
